import { Button } from '@platform/components';
import cx from 'classix';
import { useRef, useState, useEffect } from 'react';

/** A container that limits the visible content to a maximum length, with a "Read more" button to expand/collapse. */
const MaxLengthContainer = ({
  maxLength,
  children,
}: {
  maxLength: number;
  children: React.ReactNode;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [contentOverflows, setContentOverflows] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  // If the text content is longer than MAX_TEXT_CONTENT_LENGTH, collapse by default. We then
  // truncate the last content, append ellipses, and show a "Read more" button.
  useEffect(() => {
    if (containerRef.current) {
      const textContent = containerRef.current.textContent || '';
      if (textContent.length > maxLength) {
        setContentOverflows(true);
      } else {
        setContentOverflows(false);
      }
    }
  }, [maxLength]);
  return (
    <>
      {/* This line clamp does not actually truncate content to exaactly [MAX_TEXT_CONTENT_LENGTH] characters.
       * Doing that would require we dynamically calculate how many lines that number of characters are rendering to,
       * and also to reactively recalculate based on screen size. Instead, this static line clamp gets us reasonably
       * close and/or functionally presentable on all resolutions */}
      <div className={cx(contentOverflows && !isExpanded && 'line-clamp-[16]')} ref={containerRef}>
        <div className='space-y-4'>{children}</div>
      </div>
      {contentOverflows && (
        <div className='self-start'>
          <Button variant='link-color' size='sm' onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? 'Read less' : 'Read more'}
          </Button>
        </div>
      )}
    </>
  );
};

export default MaxLengthContainer;
